<template>
   <div>
      <v-container fluid>
         <component :is="userhome"></component>
      </v-container>
   </div>
</template>

<script>
   import BaseHome from "@/views/BaseHome";
   import StaffView from "@/views/StaffView";
   import ParentView from "@/views/ParentView";
   import StudentView from "@/views/StudentView";
   import VendorView from "@/views/VendorView";
   import TransporterView from "@/views/TransporterView";
   import NotFound from "@/views/NotFound";
   import UnderMaintenance from "@/views/UnderMaintenance";
   import {UserType} from "@/common/constant.js";

   export default {
      components: {
         "base-home": BaseHome,
         "staff-home": StaffView,
         "vendor-home": VendorView,
         "parent-home": ParentView,
         "student-home": StudentView,
         "under-maintenance": UnderMaintenance,
         "transporter-home": TransporterView,
         "not-found": NotFound,
      },
      data() {
         return {
            userhome: "base-home",
         };
      },
      watch: {
         "$globalstore.user.usertype": function(newval, oldval) {
            let externalOffLine = this.$globalstore.appsettings.external_offline;

            switch (newval) {
               case UserType.STAFF:
                  this.userhome = "staff-home";
                  break;
               case UserType.VENDOR:
                  this.userhome = externalOffLine ? "under-maintenance" : "vendor-home";
                  break;
               case UserType.PARENT:
                  this.userhome = externalOffLine ? "under-maintenance" : "parent-home";
                  break;
               case UserType.STUDENT:
                  this.userhome = externalOffLine ? "under-maintenance" : "student-home";
                  break;
               case UserType.TRANSPORTER:
                  this.userhome = externalOffLine ? "under-maintenance" : "transporter-home";
                  break;
               default:
                  this.$router.push({name: "Login"});
                  break;
            }
         },
      },

      methods: {
         async GetTermYear() {
            await this.$http({
               url: "/common/yearTerm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               } else {
                  this.$globalstore.termyearlist = response.data.ytdata;
               }
            });
         },
      },

      async mounted() {
         let usertype = this.$globalstore.user.usertype;
         let externalOffLine = this.$globalstore.appsettings.external_offline;

         await this.GetTermYear();
         switch (usertype) {
            case UserType.STAFF:
               this.userhome = "staff-home";
               break;
            case UserType.VENDOR:
               this.userhome = externalOffLine ? "under-maintenance" : "vendor-home";
               break;
            case UserType.PARENT:
               this.userhome = externalOffLine ? "under-maintenance" : "parent-home";
               break;
            case UserType.STUDENT:
               this.userhome = externalOffLine ? "under-maintenance" : "student-home";
               break;
            case UserType.TRANSPORTER:
               this.userhome = externalOffLine ? "under-maintenance" : "transporter-home";
               break;
         }
      },
   };
</script>
